import { FormOrganizer } from "components/forms/FormOrganizer";
import { useParams } from "react-router-dom";

const FormsPage: React.FC = () => {

    const { artistId } = useParams<string>();

    if (!artistId){
        console.log("not found");
        return <h2>Not found!</h2>
    }
    return <>
        <FormOrganizer ownerId={artistId} />
    </>
}

export default FormsPage;